import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import intl from 'react-intl-universal'
import { branch } from 'baobab-react/higher-order'
import triggerEvent from 'utils/dataLayer'

import Button from 'components/atoms/Button'
import AuthenticatedLink from 'components/molecules/AuthenticatedLink'
import ActionTypeProp from 'utils/prop_types/ActionTypeProp'

const openNewTab = {
  target: '_blank',
  rel: 'noopener',
}

const AdmissionRegistrationButton = ({ schoolSlug, schoolName, url, isTracking, isRound, type }) => {
  const className = classNames(
    'registration-btn btn',
    {
      'btn-campus': isTracking,
      'btn-white': !isTracking,
      'registration-btn--round': isRound,
    }
  )
  const onClick = () => {
    if (type) {
      if (type === 'campus') {
        triggerEvent('campus_register', { campus_name: schoolName, page_location: `/directory/${schoolSlug}`})
      } else {
        triggerEvent(`ga/${type}/button-register`)
      }
    }
  }

  return (
    <>
      {
        isTracking ?
          <AuthenticatedLink
            href={`/directory/${schoolSlug}/campus_registration`}
            className={className}
            onClick={() => onClick()}
            linkProps={openNewTab}
          >
            {intl.get('school.register')}
          </AuthenticatedLink> :
          <Button
            className={className}
            component="a"
            href={url}
            linkProps={openNewTab}
            onClick={() => onClick()}
          >
            {intl.get('school.register')}
          </Button>
      }
      <style jsx global>
        {`
          .registration-btn {
            font-size: 14px;
            font-weight: bold;
            box-shadow: 0 2px 4px 0 rgba(107, 143, 188, 0.85);
            padding: 14px 28px;
            border: none;
            margin: 8px;
            width: 100%;
            &--round {
              @media screen and (max-width: 767px) {
                border-radius: 20px;
                box-shadow: 0 2px 8px 0 rgba(107, 143, 188, 0.85);
                padding: 12px 28px;
                margin: 0;
                width: unset;
              }
            }
            @media screen and (min-width: 768px) {
              width: unset;
            }
          }
        `}
      </style>
    </>
  )
}

AdmissionRegistrationButton.propTypes = {
  schoolSlug: PropTypes.string.isRequired,
  schoolName: PropTypes.string,
  url: PropTypes.string.isRequired,
  isTracking: PropTypes.bool,
  isRound: PropTypes.bool,
  type: ActionTypeProp,
}

AdmissionRegistrationButton.defaultProps = {
  isTracking: false,
  isRound: false,
}

export { AdmissionRegistrationButton }
export default branch({
  schoolSlug: ['serverProps', 'school', 'slug'],
  schoolName: ['serverProps', 'school', 'name'],
  url: ['serverProps', 'school', 'registration_url'],
  isTracking: ['serverProps', 'school', 'registration_tracking'],
}, AdmissionRegistrationButton)
